module.exports = __webpack_public_path__ + "img/logo-cream.3993648.webp";